import PurchaseTermsModal from '/@/modules/billing/components/checkout/PurchaseTermsModal.vue';
import TermsOfUseModal from '/@/modules/billing/components/checkout/TermsOfUseModal.vue';
import FeeScheduleModal from '/@/modules/billing/components/checkout/FeeScheduleModal.vue';
import ModalService from '/@/modules/core/ui/services/ModalService';
import PrivacyPolicyModal from '@/modules/billing/components/checkout/PrivacyPolicyModal.vue';
import { ContactUsInfoMixin } from '@/modules/auth/mixins/ContactUsInfoMixin';
import Lang from '@/modules/core/app/services/Lang';
import { CompanyCainLamarrePrivacyPolicy } from '@/modules/company/constants/CompanyCainLamarrePrivacyPolicy';

export const OpensPolicyModalMixin = {
  mixins: [ContactUsInfoMixin],
  methods: {
    showPurchaseTermsModal(lineItems) {
      ModalService.show({
        parent: this,
        component: PurchaseTermsModal,
        props: {
          lineItems
        },
        ...this.modalOptions
      });
    },
    showTermsOfUseModal() {
      ModalService.show({
        parent: this,
        component: TermsOfUseModal,
        ...this.modalOptions
      });
    },
    showPrivacyPolicyModal() {
      ModalService.show({
        parent: this,
        component: PrivacyPolicyModal,
        ...this.modalOptions
      });
    },
    showFeeScheduleModal(isClearVault) {
      ModalService.show({
        parent: this,
        component: FeeScheduleModal,
        props: {
          isClearVault
        },
        ...this.modalOptions
      });
    },
    showCainLamarrePrivacyPolicyModal() {
      ModalService.show({
        parent: this,
        component: PrivacyPolicyModal,
        ...this.modalOptions,
        props: {
          policySrc: Lang.isFrench()
            ? CompanyCainLamarrePrivacyPolicy.FR_PRIVACY_POLICY
            : CompanyCainLamarrePrivacyPolicy.EN_PRIVACY_POLICY
        }
      });
    }
  }
};
